/**
 * Erstattungs-Status-Logik für Werkstatt-Rechnungen mit Auslage (Issue #583)
 *
 * Leitet den 4-Zustands-Status aus den DB-Feldern ab.
 * Kein React — direkt testbar mit Vitest.
 */

export type ErstattungsStatusKey =
  | 'noch_nicht_erstattet'
  | 'teil_erstattet'
  | 'voll_erstattet'
  | 'abgewiesen';

export interface ErstattungsStatusInfo {
  status: ErstattungsStatusKey;
  label: string;
  color: 'gray' | 'yellow' | 'green' | 'red';
}

interface ErstattungsStatusInput {
  auslage: boolean | null | undefined;
  erstattungsbetrag: number | null | undefined;
  bruttoBetrag: number | null | undefined;
  erstattungStatus: string | null | undefined;
}

export function berechneErstattungsStatus(
  input: ErstattungsStatusInput,
): ErstattungsStatusInfo {
  const { erstattungsbetrag, bruttoBetrag, erstattungStatus } = input;

  if (erstattungStatus === 'abgewiesen') {
    return { status: 'abgewiesen', label: 'abgewiesen', color: 'red' };
  }

  if (erstattungStatus === 'voll_erstattet') {
    return { status: 'voll_erstattet', label: 'voll erstattet', color: 'green' };
  }

  if (erstattungStatus === 'teil_erstattet') {
    return { status: 'teil_erstattet', label: 'teil erstattet', color: 'yellow' };
  }

  // Derive from amount if no explicit status
  if (erstattungsbetrag != null && erstattungsbetrag > 0) {
    const brutto = bruttoBetrag ?? 0;
    if (erstattungsbetrag >= brutto) {
      return { status: 'voll_erstattet', label: 'voll erstattet', color: 'green' };
    }
    return { status: 'teil_erstattet', label: 'teil erstattet', color: 'yellow' };
  }

  return { status: 'noch_nicht_erstattet', label: 'noch nicht erstattet', color: 'gray' };
}
